import axios from "axios";

export const buildingDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/building-load/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const solarDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/solar/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const gridWithoutEcosDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/grid-without-ecos/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;

  }
};

export const gridwithEcosDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/grid-with-ecos/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;
  }
};

export const batteryPowerDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/battery-power/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;
  }
};

export const BatterySOCDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/battery-soc/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;
  }
};


export const currentBatterySOC = async (client_id) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-latest-soc/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;
  }
};


export const battery_co2_emission = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/battery-co2-emmission/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;
  }
};

export const battery_average_daily_load_curve = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/battery-average-daily-load-curve/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;
  }
};


export const battery_max_demand = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/battery-max-demand/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;
  }
};

export const battery_average_weekday_weekend = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/battery-average-weekday-weekend/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });

    return response; // Return response to handle it in the component
  } catch (err) {
    console.error('Error fetching data:', err);
    return null;
  }
};







